import { apiGatewayUri, awsLdkContentInfo } from '../../environments/environment';

/**
 * Method GET
 * LDK記事詳細取得APIをコール
 * @param param.itemId 商品ID
 */
export async function getLdkDetailData(itemId) {
    const parameter = `/ldk/detail?id=${itemId}`;
    console.log(`${apiGatewayUri()}${parameter}`);
    const res = await fetch(`${apiGatewayUri()}${parameter}`);
    return res.json();
}

export async function getFileData(fileName) {
    const res = await fetch(`${awsLdkContentInfo()}${fileName}`).then(async response => {
        if (response.ok) {
            return response.text();
        } else {
            throw new Error(`Request failed: ${response.status}`);
        }
    })
        .catch(err => {
            console.error(err);
            return '';
        });
    return res;
}

/**
 * Method PUT
 * PV数更新APIをコール
 * @param param 商品情報
 */
export async function putLdkPV(param) {
    const request = {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'content-type': 'application/json',
        },
        body: JSON.stringify(param),
    };

    const res = await fetch(`${apiGatewayUri()}/ldk/pv`, request)
        .then((response) => {
            console.log(response);
            return response.json();
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return res;
}
